import { call, take, put } from 'redux-saga/effects';
import { get, putMethod, deleteMethod, post } from '../../utils/api';
import settings from '../../utils/settings';
import {
  GET_APPLICATION_NOTIFICATIONS_REQUEST,
  GET_APPLICATION_NOTIFICATIONS_SUCCESS,
  GET_APPLICATION_NOTIFICATIONS_FAILURE,
  READ_APPLICATION_NOTIFICATIONS_REQUEST,
  READ_APPLICATION_NOTIFICATIONS_FAILURE,
  MARK_NOTIFICATION_AS_SEEN_REQUEST,
  DELETE_READ_NOTIFICATION_REQUEST,
  GET_SOLARGRAF_SESSION,
  GET_SOLARGRAF_SESSION_SUCCESS,
  VERIFY_SOLARGRAF_SESSION,
  VERIFY_SOLARGRAF_EMAIL,
  GET_SOLARGRAF_ACCESS,
  SET_SOLARGRAF_ACCESS_GRANT,
  GET_FLEET_DASHBOARD_LINK,
  SET_FLEET_DASHBOARD_LINK,
  GET_SYSTEM_OLDVIEW_LINK,
  SET_SYSTEM_OLDVIEW_LINK
} from './constants';
import { setSolargrafToken } from '../../utils/helper';

export function* getApplicationNotificationsFlow() {
  while (true) {
    const request = yield take(GET_APPLICATION_NOTIFICATIONS_REQUEST);
    try {
      let response;
      const { successCbk = () => { }, page = 0, size = 20 } = request.payload;
      response = yield call(get, {
        url: settings.einCoreUrl(`notifications/?page=${page}&size=${size}`),
        withBearer: true
      });
      if (response.success) {
        const notificationList = response.result.notices || [];
        const unseenNotificationCount = response.result['unseen_notifications_count'];
        successCbk(notificationList);
        yield put({
          type: GET_APPLICATION_NOTIFICATIONS_SUCCESS,
          notificationList: notificationList,
          unseenNotificationCount: unseenNotificationCount
        });
      } else {
        yield put({
          type: GET_APPLICATION_NOTIFICATIONS_FAILURE,
          error: response.result.message || response.result.messages
        });
      }
    } catch (error) {
      yield put({ type: GET_APPLICATION_NOTIFICATIONS_FAILURE, error });
      console.log('Saga: getApplicationNotifications ', error);
    }
  }
}

export function* readApplicationNotificationFlow() {
  while (true) {
    const request = yield take(READ_APPLICATION_NOTIFICATIONS_REQUEST);
    try {
      let response;
      const { installerId, successCbk = () => { } } = request.payload;
      response = yield call(putMethod, {
        url: settings.einCoreUrl(`notifications/${installerId}`),
        withBearer: true
      });
      if (response.success) {
        successCbk();
      } else {
        yield put({
          type: READ_APPLICATION_NOTIFICATIONS_FAILURE,
          error: response.result.message || response.result.messages
        });
      }
    } catch (error) {
      yield put({ type: READ_APPLICATION_NOTIFICATIONS_FAILURE, error });
      console.log('Saga: readApplicationNotificationFlow ', error);
    }
  }
}

export function* markNotificationSeenFlow() {
  while (true) {
    const request = yield take(MARK_NOTIFICATION_AS_SEEN_REQUEST);
    try {
      let response;
      const { lastUpdatedAt, successCbk = () => { } } = request.payload;
      response = yield call(putMethod, {
        url: settings.einCoreUrl(`notifications/seen/${lastUpdatedAt}`),
        withBearer: true
      });
      if (response.success) {
        successCbk();
      } else {
        console.log('Saga: readApplicationNotificationFlow ');
      }
    } catch (error) {
      console.log('Saga: readApplicationNotificationFlow ', error);
    }
  }
}

export function* deleteApplicationNotificationFlow() {
  while (true) {
    const request = yield take(DELETE_READ_NOTIFICATION_REQUEST);
    try {
      let response;
      const { notificationId, successCbk = () => { } } = request.payload;
      response = yield call(deleteMethod, {
        url: settings.einCoreUrl(`notifications/${notificationId}`),
        withBearer: true
      });
      if (response.success) {
        successCbk();
      } else {
        console.log('Saga: deleteApplicationNotificationFlow ', response.result.message || response.result.messages);
      }
    } catch (error) {
      console.log('Saga: deleteApplicationNotificationFlow ', error);
    }
  }
}

export function* getSolargrafSession() {
  while (true) {
    const request = yield take(GET_SOLARGRAF_SESSION);
    const { token, successCbk, failureCbk } = request.payload;
    try {
      let response;
      response = yield call(post, {
        url: settings.solargrafApiUrl(`enlm/sessions?token=${token}`)
      });
      const { success, status, result } = response;
      if (success && status === 200) {
        setSolargrafToken(result.token);
        yield put({
          type: GET_SOLARGRAF_SESSION_SUCCESS,
          solargrafToken: result.token
        });
        successCbk(result);
      } else {
        failureCbk();
      }
    } catch (error) {
      failureCbk();
    }
  }
}

export function* verifySolargrafSession() {
  while (true) {
    const request = yield take(VERIFY_SOLARGRAF_SESSION);
    const { solargrafToken, successCbk, failureCbk } = request.payload;

    try {
      let response;
      response = yield call(get, {
        url: settings.solargrafApiUrl(`me`),
        withBearer: true,
        externalServiceToken: solargrafToken
      });
      const { success, status } = response;
      if (success && status === 200) {
        successCbk();
      } else {
        failureCbk();
      }
    } catch (error) {
      failureCbk();
    }
  }
}

export function* verifySolargrafEmail() {
  while (true) {
    const request = yield take(VERIFY_SOLARGRAF_EMAIL);
    const { token, successCbk = () => { }, failureCbk = () => { } } = request.payload;
    try {
      let response;
      response = yield call(get, {
        url: settings.solargrafApiUrl(`enlm/verification?token=${token}`)
      });
      const { success, status } = response;
      if (success && status === 200) {
        successCbk();
      } else {
        failureCbk();
      }
    } catch (error) {
      failureCbk();
    }
  }
}

let requestSent = false;
export function* requestSolargrafAccess() {
  while (true) {
    const request = yield take(GET_SOLARGRAF_ACCESS);
    const { successCbk = () => { }, failureCbk = () => { } } = request.payload;
    if (!requestSent) {
      try {
        requestSent = true;
        const response = yield call(post, {
          url: settings.getApiUrl('api_internal/solargraf/request_access')
        });
        const { success, status } = response;
        if (success && status === 200) {
          successCbk();
        } else {
          failureCbk();
        }
        requestSent = false;
      } catch (error) {
        failureCbk();
        requestSent = false;
      }
    }
  }
}

let grantAccessRequestSent = false;
export function* grantSolargrafAccess() {
  while (true) {
    const request = yield take(SET_SOLARGRAF_ACCESS_GRANT);
    const { otp, successCbk = () => { }, failureCbk = () => { } } = request.payload;
    if (!grantAccessRequestSent) {
      try {
        grantAccessRequestSent = true;
        const response = yield call(post, {
          url: settings.getApiUrl(`api_internal/solargraf/grant_access?otp=${otp}`)
        });
        const { success, status } = response;
        if (success && status === 200) {
          successCbk();
        } else {
          failureCbk();
        }
        grantAccessRequestSent = false;
      } catch (error) {
        failureCbk();
        grantAccessRequestSent = false;
      }
    }
  }
}

export function* getFleetDashBoardLinkFlow() {
  while (true) {
    yield take(GET_FLEET_DASHBOARD_LINK);
    try {
      let response;
      response = yield call(get, {
        url: settings.getApiUrl('service/enlm_ms/api_internal/account/fleet_dashboard_url')
      });
      const { success, status, result } = response;
      if (success && status === 200) {
        yield put({
          type: SET_FLEET_DASHBOARD_LINK,
          payload: result.url
        });
      }
    } catch (error) {
      console.log('Saga: getFleetDashBoardLinkFlow', error);
    }
  }
}

export function* systemOldViewCheck() {
  while (true) {
    yield take(GET_SYSTEM_OLDVIEW_LINK);
    try {
      let response;
      response = yield call(get, {
        url: settings.getApiUrl('service/enlm_ms/api_internal/sites/old_view')
      });
      if (response.success) {
        const { result } = response;
        yield put({ type: SET_SYSTEM_OLDVIEW_LINK, systemOldView: result });
      }
    } catch (error) {
      console.log('Saga: getoldview:', error);

    }
  }
}